<ng-container *ngIf="showNotifications">
    <div id="notification-container">
        <ng-container *ngIf="consentsData">
            <div class="notification-bar" *ngFor="let consent of consentsData, let index=index">
                <div class="notification-container notification-container--consent height-auto d-flex align-items-center notification-done">
                    <div class="notification-label" *ngIf="consent.modules?.length != 0">
                        <span>{{getModulesLabel(consent.modules)}}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-center icon consent-icon">
                            <mat-icon>assignment</mat-icon>
                        </div>
                    </div>
                    <div class="desc" [innerHTML]="consent.htmlMessage" [ngClass]="getNotificationStyle(consent.modules)"></div>

                    <button mat-raised-button class="button button--accept done" (click)="approveConsent(consent.id)" *ngIf="!isSendingDecisions(consent.id)">
                        {{ 'accept' | translate}}
                    </button>
                    <button mat-button class="button button--accept done" (click)="rejectConsentDialog(consent.id, consent.modules)" *ngIf="!isSendingDecisions(consent.id)">
                        {{ 'reject' | translate}}
                    </button>
                    <mat-spinner class="pr-5" *ngIf="isSendingDecisions(consent.id)" [diameter]="30"></mat-spinner>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="notificationsData">
            <div class="notification-bar"
                *ngFor="let notificationData of notificationsData, let index=index, let last=last">
                <div class="notification-container height-auto d-flex align-items-center"
                    [ngClass]="['notification-'+getNotificationBarType(notificationData.type),getNotificationStyle(notificationData.modules)]">
                    <div class="notification-label">
                        <span>{{getModulesLabel(notificationData.modules)}}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-center icon"
                            [ngSwitch]="'notification-'+getNotificationBarType(notificationData.type)">
                            <mat-icon *ngSwitchCase="'notification-information'">info</mat-icon>
                            <mat-icon *ngSwitchCase="'notification-warning'">warning</mat-icon>
                            <mat-icon *ngSwitchCase="'notification-done'">done</mat-icon>
                        </div>
                    </div>
                    <div class="desc" [innerHTML]="notificationData.htmlMessage"></div>
                    <button mat-icon-button class="button" *ngIf="notificationData.closable"
                        (click)="close(notificationData.id,index)"><mat-icon>close</mat-icon></button>
                    <span *ngIf="!notificationData.closeable"></span>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>